import { apiFetch } from "./client";

export interface AgentAccessEntry {
  id: string;
  agentId: string;
  tenantUserId: string | null;
  groupId: string | null;
  createdAt: string;
  userName: string | null;
  userEmail: string | null;
  groupName: string | null;
  groupSource: string | null;
}

export const agentAccessApi = {
  list: (companyId: string, agentId: string) =>
    apiFetch<AgentAccessEntry[]>(`/companies/${companyId}/agents/${agentId}/access`),

  grant: (companyId: string, agentId: string, data: { tenantUserId?: string; groupId?: string }) =>
    apiFetch<AgentAccessEntry>(`/companies/${companyId}/agents/${agentId}/access`, {
      method: "POST",
      body: JSON.stringify(data),
    }),

  revoke: (companyId: string, agentId: string, accessId: string) =>
    apiFetch<void>(`/companies/${companyId}/agents/${agentId}/access/${accessId}`, {
      method: "DELETE",
    }),

  listAccessible: (companyId: string) =>
    apiFetch<unknown[]>(`/companies/${companyId}/accessible-agents`),
};
